module.exports = __webpack_public_path__ + "static/media/alicelee.ab55ae57.jpeg";